<template>
    <div class="bg-gray-100">
        <div class="min-h-screen flex flex-col justify-center items-center">
            <div class="bg-white p-7 rounded-2xl shadow-md text-center">
                <div v-if="paymentStatus === 'success'">
                    <div class="text-green-600 mb-4">
                        <Icon icon="octicon:check-circle-fill-16" height="50" class="flex-shrink-0 mx-auto" />
                    </div>
                    <h1 class="text-2xl font-bold text-gray-800 mb-4">¡Pago Completado!</h1>
                    <p class="text-gray-600 mb-4">Gracias por tu compra. Tu transacción ha sido procesada con éxito.</p>
                    <p v-if="referenceCode" class="text-gray-600 mb-4">
                        Referencia de la transacción: <span class="font-semibold">{{ referenceCode }}</span>
                    </p>
                    <p v-if="paymentId" class="text-gray-600 mb-4">
                        ID del pago: <span class="font-semibold">{{ paymentId }}</span>
                    </p>
                    <p v-if="amount" class="text-gray-600 mb-4">
                        Precio: <span class="font-semibold">{{ amount }} {{ currency }}</span>
                    </p>
                    <p class="text-gray-600 mb-8">Si tienes alguna duda, no dudes en contactarnos.</p>
                </div>

                <div v-else-if="paymentStatus === 'pending'">
                    <div class="text-yellow-500 mb-4">
                        <Icon icon="octicon:clock-fill-16" height="50" class="flex-shrink-0 mx-auto" />
                    </div>
                    <h1 class="text-2xl font-bold text-gray-800 mb-4">¡Pago pendiente!</h1>
                    <p class="text-gray-600 mb-4">Tu pago está en proceso. Te avisaremos cuando se confirme.</p>
                    <p v-if="paymentId" class="text-gray-600 mb-4">
                        ID del pago: <span class="font-semibold">{{ paymentId }}</span>
                    </p>
                    <p class="text-gray-600 mb-8">Si tienes alguna duda, no dudes en contactarnos.</p>
                </div>

                <div v-else>
                    <div class="text-red-600 mb-4">
                        <Icon icon="octicon:x-circle-fill-16" height="50" class="flex-shrink-0 mx-auto" />
                    </div>
                    <h1 class="text-2xl font-bold text-gray-800 mb-4">¡Pago fallido!</h1>
                    <p class="text-gray-600 mb-4">Intenta nuevamente más tarde.</p>
                    <p class="text-gray-600 mb-8">Si tienes alguna duda, no dudes en contactarnos.</p>
                </div>

                <button class="mob-btn mob-cta-gold" @click="goToDashboard()">
                    Volver al Inicio
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from "@iconify/vue2";

export default {
    name: "PaymentResponse",
    components: {
        Icon,
    },
    data() {
        return {
            paymentStatus: '',
            referenceCode: '',
            amount: 0,
            currency: '',
            paymentId: '',
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('lapTransactionState')) {
            this.paymentStatus = this.mapPayUStatus(urlParams.get('lapTransactionState'));
            this.referenceCode = urlParams.get('referenceCode');
            this.amount = urlParams.get('TX_VALUE');
            this.currency = urlParams.get('currency');
        } else if (urlParams.get('status') || urlParams.get('collection_status')) {
            const rawStatus = urlParams.get('status') || urlParams.get('collection_status');
            this.paymentStatus = this.mapMercadoPagoStatus(rawStatus);
            this.paymentId = urlParams.get('payment_id') || urlParams.get('collection_id') || '';
            this.referenceCode = urlParams.get('external_reference') || '';
            this.amount = urlParams.get('transaction_amount') || urlParams.get('amount') || 0;
            this.currency = urlParams.get('currency_id') || 'COP';
        } else {
            this.goToDashboard();
        }
    },
    methods: {
        mapPayUStatus(state) {
            return state === 'APPROVED' ? 'success' : 'failure';
        },
        mapMercadoPagoStatus(status) {
            const normalized = (status || '').toLowerCase();
            if (normalized === 'approved') {
                return 'success';
            }
            if (['pending', 'in_process', 'in_mediation'].includes(normalized)) {
                return 'pending';
            }
            if (['rejected', 'cancelled', 'failure', 'charged_back', 'refunded'].includes(normalized)) {
                return 'failure';
            }
            return 'pending';
        },
        goToDashboard() {
            this.$router.push({ path: '/dashboard' });
        }
    }
}
</script>